import React from "react";
import { Image } from "react-native";
import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded";
import TooltipV3 from "../TooltipV3";
import { THEME_COLORS } from "../../themes";

function InfoTooltip({ info }) {
  return (
    <TooltipV3 title={info}>
      <HelpOutlineRoundedIcon fontSize="small" style={{ color: THEME_COLORS.textGrey }} />
    </TooltipV3>
  );
}

export default InfoTooltip;
